import { uuid } from "uuidv4";

const state = {
  alerts: [],
};

const mutations = {
  SET_ALERT(state, payload) {
    const newId = uuid();
    const data = { ...payload, id: newId };
    state.alerts = [...state.alerts, data];
    setTimeout(
      () => (state.alerts = state.alerts.filter((id) => id === newId)),
      3000
    );
  },
};

const getters = {
  getAlerts: (state) => {
    return state.alerts;
  },
};

export default {
  state,
  mutations,
  getters,
};
